module.exports = __webpack_public_path__ + "static/media/P99.7690413a.png";